<script>
export default {
    name: "CashOutReport",

    data() {

        return {
            cashOuts: [],
        };
    },

    mounted() {

        Promise.allSettled([ this.fetchCashOut(), ]).then(() => {
            window.print();
        }).catch(() => {});
    },

    methods: {

        fetchCashOut() {
            let url = `AccountsReports/GetCashOutReport?Datefrom=${this.$route.query.dateFrom}&Dateto=${this.$route.query.dateTo}`;
            url += this.$route.query.search ? `&SearchText=${this.$route.query.search}` : ``;
            url += this.$route.query.user ? `&UserName=${this.$route.query.user}` : ``;

            return this.$http.get(url).then(response => {
                this.cashOuts = response.data;
            }).catch(() => {});
        },
    },
}
</script>
<template>
    <div class="flex flex-wrap">
        <div class="w-full my-2 text-center">
            <h5 class="font-medium">Cash Out Report</h5>
        </div>
        <table class="table table-bordered">
            <thead class="text-sm">
                <tr class="flex w-full">
                    <th class="p-tiny w-1/6">Authorised By</th>
                    <th class="p-tiny w-1/6">Received By</th>
                    <th class="p-tiny w-1/6">Item</th>
                    <th class="p-tiny w-1/6">Memo</th>
                    <th class="p-tiny w-1/12">Qty</th>
                    <th class="p-tiny w-1/6">Username</th>
                    <th class="p-tiny w-1/6">Approved By</th>
                    <th class="p-tiny w-1/12">Amount</th>
                </tr>
            </thead>
            <tfoot>
                <tr class="flex w-full">
                    <th class="p-tiny w-1/6"></th>
                    <th class="p-tiny w-1/12"></th>
                    <th class="p-tiny w-1/12"></th>
                    <th class="p-tiny w-1/12"></th>
                    <th class="p-tiny w-1/12"></th>
                    <th class="p-tiny w-1/12"></th>
                    <th class="p-tiny w-1/12"></th>
                    <th class="p-tiny w-1/3 text-right">Total Amt: {{ totalCashout | numberFormat }}</th>
                </tr>
            </tfoot>
            <tbody class="text-xs flex flex-col items-center">
                <tr class="w-full flex" v-for="(cashOut, idx) in cashOuts" :key="idx">
                    <td class="p-tiny w-1/6">{{ cashOut.authorisedBy }}</td>
                    <td class="p-tiny w-1/6">{{ cashOut.receivedBy }}</td>
                    <td class="p-tiny w-1/6">{{ cashOut.item }}</td>
                    <td class="p-tiny w-1/6">{{ cashOut.memo }}</td>
                    <td class="p-tiny w-1/12">{{ cashOut.quantity }}</td>
                    <td class="p-tiny w-1/6">{{ cashOut.userName }}</td>
                    <td class="p-tiny w-1/6">{{ cashOut.approvedBy }}</td>
                    <td class="p-tiny w-1/12">{{ cashOut.amount | numberFormat }}</td>
                </tr>
            </tbody>
        </table>
    </div>
</template>